var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.numPages),function(i){return _c('pdf',{key:i,staticStyle:{"height":"100%"},attrs:{"page":i,"src":_vm.src}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }